import Header from "../home/header";
import imgHolder from '../../img/customer.svg';
import { useLocation, useNavigate } from "react-router";
import { useState } from "react";
import Loading from "../home/Loading";
import { ApiClient } from "../../utils/api-client";
import { AxiosError } from "axios";
import { getCityNames } from "postcodes-tz";

const CustomerForm = () => {
  let navigate = useNavigate();
  var location = useLocation();
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  var storedData = location.state || {};
  const [ isLoading, setIsLoading ] = useState( false );
  const [ feedback, setFeedback ] = useState( "" );
  const [ customer, setCustomer ] = useState( {} );
  const [ preview, setPreview ] = useState( imgHolder );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

  const handleSubmit = ( e ) => {
    e.preventDefault();
    saveCustomer( customer );
  }
  const handleRegionChange = ( e ) => {
    const selectedRegion = e.target.value;
    setCustomer( prev => ( { ...prev, region: selectedRegion } ) );
  }
  const handleChange = ( e ) => {
    const { name, value } = e.target;
    setCustomer( prev => ( { ...prev, [ name ]: value } ) );
  }
  const uploadImage = ( e ) => {
    e.preventDefault();
    let file = e.target.files[ 0 ];
    if ( file ) {
      let reader = new FileReader();
      reader.addEventListener( 'load', () => {
        const dataUrl = reader.result;
        setPreview( dataUrl );
        setCustomer( prev => ( { ...prev, customerImage: dataUrl } ) );
      }, false );
      reader.readAsDataURL( file );
    }
  }
  const saveCustomer = async ( customer ) => {
    setIsLoading( true );
    if ( !customer.name || !customer.address || !customer.phone ) {
      setFeedback( "Please fill all required fields" );
      setIsLoading( false );
      return;
    }
    try {
      const result = await apiClient.post( 'customers', customer );
      if ( result.status === 201 ) {
        setIsLoading( false );
        navigate( "/customers", { replace: true } );
      } else {
        setFeedback( 'Oops! Something went wrong' );
        setIsLoading( false );
      }
    }
    catch ( e ) {
      setIsLoading( false );
      setFeedback( 'Oops! Something went wrong' );
      if ( e instanceof AxiosError && e.status === 401 ) {
        navigate( '/signin', { replace: true, state: { target: '/customers/new' } } );
        return;
      }
    }
  }
  return ( <>
    <Header auth={loginState} />
    <section className="container mx-auto mt-8">
      {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="feedback">{feedback}</div> : null}

      <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5 mb-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
            <p className="text-xs uppercase tracking-wide text-gray-500">Module</p>
            <p className="text-lg font-semibold text-gray-800 mt-1">Customers</p>
          </div>
          <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
            <p className="text-xs uppercase tracking-wide text-gray-500">Action</p>
            <p className="text-lg font-semibold text-gray-800 mt-1">Create</p>
          </div>
          <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
            <p className="text-xs uppercase tracking-wide text-gray-500">Status</p>
            <p className="text-lg font-semibold text-gray-800 mt-1">Draft</p>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white shadow-md p-4 md:p-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <p className="text-sm uppercase tracking-wide text-gray-500">Customer Setup</p>
            <p className="text-2xl font-semibold text-gray-800">Create Customer</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          <div className="md:col-span-1 rounded-xl border border-gray-200 bg-gray-50 p-4 text-center">
            <img src={preview} alt="Customer feature" className="h-36 w-36 rounded-full object-cover border-2 border-primary-200 mx-auto" />
            <p className="text-sm text-gray-500 mt-3">Image Preview</p>
          </div>
          <div className="md:col-span-2">
            <form id="new_customer_form"
              className="w-full"
              method="post" onSubmit={handleSubmit}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="form-group my-1 sm:col-span-2">
                  <label htmlFor="name" className="text-sm text-gray-600">Customer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name" required
                    onChange={handleChange}
                    placeholder="Customer name"
                  />
                </div>
                <div className="form-group my-1 sm:col-span-2">
                  <label htmlFor="customer_image" className="text-sm text-gray-600">Customer Image</label>
                  <input
                    type="file"
                    className="form-control"
                    id="customer_image"
                    name="customer_image"
                    placeholder="Upload customer image" onChange={uploadImage}
                  />
                </div>
                <div className="form-group my-1 sm:col-span-2">
                  <label htmlFor="address" className="text-sm text-gray-600">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    name="address" required
                    onChange={handleChange}
                    placeholder="Address"
                  />
                </div>
                <div className="form-group my-1">
                  <label htmlFor="region" className="text-sm text-gray-600">Region</label>
                  <select
                    className="form-control"
                    id="region"
                    name="region" required
                    onChange={handleRegionChange}
                  >
                    <option value="">Select Region</option>
                    {getCityNames( 'ASC' ).map( ( city, index ) => (
                      <option key={index} value={city}>{city}</option>
                    ) )}
                  </select>
                </div>
                <div className="form-group my-1">
                  <label htmlFor="phone" className="text-sm text-gray-600">Phone Number</label>
                  <input
                    type="number"
                    className="form-control"
                    id="phone"
                    name="phone" required
                    placeholder="Phone Number"
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group my-1 sm:col-span-2">
                  <label htmlFor="email" className="text-sm text-gray-600">E-mail</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="E-mail"
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  {isLoading ? <Loading /> :
                    <input
                      type="submit"
                      className="form-control bg-success"
                      id="btnSubmit"
                      name="btnSubmit"
                      value="Create Customer"
                    />}
                </div>
                <div>
                  <input onClick={() => { navigate( "/customers", { replace: true, state: storedData } ) }}
                    type="button"
                    className="form-control"
                    value="Back to Customers"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section></> )
}
export default CustomerForm;
